/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore
 */
export interface PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore {
    /**
     * 
     * @type {number}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore
     */
    totalSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore
     */
    id?: string;
}

/**
 * Check if a given object implements the PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore interface.
 */
export function instanceOfPartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeFromJSON(json: any): PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore {
    return PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeFromJSONTyped(json, false);
}

export function PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalSeconds': !exists(json, 'totalSeconds') ? undefined : json['totalSeconds'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeToJSON(value?: PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalSeconds': value.totalSeconds,
        'id': value.id,
    };
}

